<script lang="ts" setup>
defineProps<{
  title: string
  lastModified: string
}>()
</script>

<template>
  <div data-el="SiteLegalPage">
    <SitePageHero :title="title" align="left">
      <template #description>
        <p class="text-base text-secondary">
          Last modified: {{ lastModified }}
        </p>
      </template>
    </SitePageHero>

    <section class="mx-auto w-full max-w-350 px-5 py-15">
      <article class="legal-body mx-auto max-w-215.5">
        <slot />
      </article>
    </section>
  </div>
</template>

<style scoped>
@reference "@forgd/ui-kit/styles/tailwind.css";

.legal-body {
  @apply flex flex-col font-display text-base leading-relaxed text-secondary;
}
.legal-body > :deep(* + *) { @apply mt-6; }
.legal-body :deep(h2) { @apply pt-6 text-2xl font-semibold leading-[1.3] text-primal; }
.legal-body :deep(h3) { @apply pt-4 text-xl font-semibold leading-[1.3] text-primal; }
.legal-body :deep(strong) { @apply font-semibold text-primal; }
.legal-body :deep(ul) { @apply flex list-disc flex-col gap-2 pl-6; }
.legal-body :deep(ol) { @apply flex list-decimal flex-col gap-2 pl-6; }
.legal-body :deep(li > ul), .legal-body :deep(li > ol) { @apply mt-2; }
.legal-body :deep(a) { @apply text-accent underline; }
</style>
